
































import './VideoLoadingOverlay.scss'
import { computed, defineComponent, toRef } from '@vue/composition-api'
import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'
import { SceneSourceType } from '@/modules/scenes/types'
import { AssetType } from '@/types/assets'
import { Cast } from '@/modules/casts/classes'
import Media from '@/modules/kisweui/components/Media'


export default defineComponent({
  name: 'VideoLoadingOverlay',
  components: {
    ClipLoader,
    Media
  },
  props: {
    cast: {
      type: Object as () => Cast|null,
      required: false,
      default: null
    },
    hasNoValidSource: {
      type: Boolean,
      required: false,
      default: false
    },
    isLoading: {
      type: Boolean,
      required: true,
      default: false
    },
    showVideoPlaceholder: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholderUrl: {
      type: String as () => string|null,
      required: false,
      default: null
    },
    sceneId: {
      type: String as () => string|null,
      required: false,
      default: null
    },
    showIfBooting: {
      type: Boolean,
      required: false,
      default: false
    },
    showCasterIsJoining: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup (props) {
    const cast = toRef(props, 'cast')
    const isBooting = computed(() => cast.value?.isBooting ?? false)
    const isTempCast = computed(() => cast.value?.isTempCast ?? false)
    const showNoClips = computed(() => {
      if (props.sceneId === null || cast.value === null) return false
      if (cast.value.getSceneSourceType(props.sceneId) !== SceneSourceType.Playlist) return false
      if (Object.keys(cast.value.getSceneContents(props.sceneId, [AssetType.Video])).length > 0) return false
      return true
    })
    return {
      isBooting,
      isTempCast,
      showNoClips
    }
  }
})
